import React from 'react';
import { Box, Typography } from '@mui/material';

export interface HealthBannerItem {
  value: string | number;
  label: string;
  delta?: string;
  deltaColor?: string;
}

interface MemberHealthBannerProps {
  items: HealthBannerItem[];
  gradient?: string;
}

const MemberHealthBanner: React.FC<MemberHealthBannerProps> = ({
  items,
  gradient = 'linear-gradient(135deg, #0f3d50, #1A5F7A)',
}) => {
  return (
    <Box
      sx={{
        background: gradient,
        borderRadius: '16px',
        p: '20px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        mb: 2,
      }}
    >
      {items.map((item, index) => (
        <React.Fragment key={item.label}>
          {index > 0 && (
            <Box
              sx={{
                width: '1px',
                height: '56px',
                bgcolor: 'rgba(255,255,255,0.15)',
                flexShrink: 0,
              }}
            />
          )}
          <Box sx={{ textAlign: 'center', flex: 1, minWidth: 0 }}>
            <Typography
              sx={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: '26px',
                fontWeight: 800,
                color: '#D4AC0D',
                lineHeight: 1.2,
              }}
            >
              {item.value}
            </Typography>
            <Typography
              sx={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: '11px',
                fontWeight: 600,
                color: 'rgba(255,255,255,0.65)',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                mt: 0.5,
              }}
            >
              {item.label}
            </Typography>
            {item.delta && (
              <Typography
                sx={{
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: '11px',
                  fontWeight: 500,
                  color: item.deltaColor || 'rgba(255,255,255,0.5)',
                  mt: 0.3,
                }}
              >
                {item.delta}
              </Typography>
            )}
          </Box>
        </React.Fragment>
      ))}
    </Box>
  );
};

export default MemberHealthBanner;
